import $ from "jquery";
/* eslint-disable */
import slick from "slick-carousel";
/* eslint-enable */

const elements = {
  $carousels: $(".js-card-carousel-slider"),
};

const matchMobileWidth = window.matchMedia("(max-width: 61.25em)");

function toggleCarousel(match, carousel) {
  match ? setCarousel(carousel) : removeCarousel(carousel);
}

function setCarousel(carousel) {
  if (carousel.el.hasClass("slick-initialized")) return;

  if (!carousel.showDesktop) {
    carousel.el.slick({
      dots: carousel.dots,
      speed: 800,
      slidesToShow: carousel.mobileSlidesToShow,
      slidesToScroll: carousel.mobileSlidesToScroll,
      infinite: false,
      arrows: false,
      rows: carousel.mobileRows,
      slidesPerRow: carousel.mobileSlidesPerRow,
    });
  } else {
    carousel.el.slick({
      dots: carousel.dots,
      speed: 800,
      slidesToShow: carousel.mobileSlidesToShow,
      slidesToScroll: carousel.mobileSlidesToScroll,
      infinite: false,
      arrows: false,
      rows: carousel.mobileRows,
      slidesPerRow: carousel.mobileSlidesPerRow,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1225,
          settings: {
            slidesToShow: carousel.desktopSlidesToShow,
            slidesToScroll: carousel.desktopSlidesToScroll,
            rows: carousel.desktopRows,
            slidesPerRow: carousel.desktopSlidesPerRow,
          },
        },
      ],
    });
  }
  if (carousel.arrows) {
    carousel.next.show();
    carousel.prev.show();
  }
  setButtonStyling(carousel, 1);
}

function removeCarousel(carousel) {
  if (!carousel.el.hasClass("slick-initialized")) return;
  carousel.el.slick("unslick");
  carousel.next.hide();
  carousel.prev.hide();
}

function setButtonStyling(carousel) {
  toggleArrowState(carousel);
  const currentSlide = carousel.el.slick("slickCurrentSlide");
  const slides = carousel.slides.length;

  if (
    currentSlide + carousel.el.slick("slickGetOption", "slidesToShow") >=
      slides ||
    (currentSlide + 1) * carousel.el.slick("slickGetOption", "slidesPerRow") >=
      slides ||
    (currentSlide + 1) * carousel.el.slick("slickGetOption", "rows") >= slides
  ) {
    carousel.next.addClass("is-disabled");
  } else {
    carousel.next.removeClass("is-disabled");
  }

  if (currentSlide === 0) {
    carousel.prev.addClass("is-disabled");
  } else {
    carousel.prev.removeClass("is-disabled");
  }
}

function toggleArrowState(carousel) {
  if (
    carousel.el.slick("slickGetOption", "slidesToShow") !==
    carousel.slides.length
  ) {
    carousel.next.show();
    carousel.prev.show();
  } else {
    carousel.next.hide();
    carousel.prev.hide();
  }
}

function init() {
  if (elements.$carousels.length > 0) {
    elements.$carousels.each((index, el) => {
      const parent = $(el).parent();
      const carousel = {
        el: $(el),
        slides: parent.find(".js-card-carousel-slide"),
        next: parent.find(".js-card-carousel-next"),
        prev: parent.find(".js-card-carousel-prev"),
        dots: parent.data("dots") || false,
        arrows: parent.data("arrows") || false,
        showDesktop: parent.data("showDesktop") || false,
        mobileSlidesToShow: parent.data("mobileSlidesToShow") || 1.3,
        mobileSlidesToScroll: parent.data("mobileSlidesToScroll") || 1,
        mobileRows: parent.data("mobileRows") || 1,
        mobileSlidesPerRow: parent.data("mobileSlidesPerRow") || 1,
        desktopSlidesToShow: parent.data("desktopSlidesToShow") || 3,
        desktopSlidesToScroll: parent.data("desktopSlidesToScroll") || 1,
        desktopRows: parent.data("desktopRows") || 1,
        desktopSlidesPerRow: parent.data("desktopSlidesPerRow") || 1,
      };

      if (carousel.el && carousel.slides.length > 0) {
        if (carousel.slides.length < 1) return carousel.el.parent().show();

        carousel.prev.on("click", () => {
          carousel.el.slick("slickPrev");
        });

        carousel.next.on("click", () => {
          carousel.el.slick("slickNext");
        });

        carousel.el.on("afterChange", (e, slick, currentSlide) => {
          setButtonStyling(carousel, currentSlide);
        });

        if (!carousel.showDesktop) {
          parent.addClass("is-mobile-only");
          matchMobileWidth.addEventListener("change", (e) => {
            toggleCarousel(e.matches, carousel);
          });
          toggleCarousel(matchMobileWidth.matches, carousel);
        } else {
          setCarousel(carousel);
        }
      }
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/developers/card-carousel/card-carousel.js